// import Home from '../views/Home.vue'
// import Adverts from '../views/Adverts.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: {
      title: 'app.page_home',
      requiresAuth: false,
    },
    children: [
      {
        path: 'faq',
        name: 'faq',
        component: () => import(/* webpackChunkName: "home" */ '../views/FAQModal.vue'),
        meta: {
          title: 'app.page_home',
          requiresAuth: false,
        },
      },
      {
        path: '/article/:alias',
        name: 'article',
        components: {
          default: () => import(/* webpackChunkName: "article" */ '../views/Article.vue'),
        },
        meta: {
          title: 'app.page_article',
          requiresAuth: false,
        },
      },
      {
        path: '/contact',
        name: 'contact',
        components: {
          default: () => import(/* webpackChunkName: "article" */ '../views/Contact.vue'),
        },
        meta: {
          title: 'app.page_contact',
          requiresAuth: false,
        },
      },
    ],
  },

  {
    path: '/find-a-place',
    name: 'search',
    component: () => import(/* webpackChunkName: "properties" */ '../views/Adverts.vue'),
    meta: {
      title: 'app.page_advert_search',
      requiresAuth: false,
    },
    children: [
      {
        path: 'property/:uuid',
        name: 'advert-detail-modal',
        component: () =>
          import(/* webpackChunkName: "properties-details" */ '../views/AdvertDetailsModal.vue'),
        meta: {
          title: 'app.page_advert_details',
          requiresAuth: false,
        },
      },
    ],
  },

  {
    path: '/property/:uuid',
    name: 'advert-details',
    components: {
      default: () =>
        import(/* webpackChunkName: "properties-details" */ '../views/AdvertDetails.vue'),
    },
    meta: {
      title: 'app.page_advert_details',
      requiresAuth: false,
    },
  },
  {
    path: '/property',
    name: 'advert-list',
    components: {
      default: () => import(/* webpackChunkName: "properties-details" */ '../views/AdvertList.vue'),
    },
    meta: {
      title: 'Property List',
      requiresAuth: false,
    },
  },

  // Profile
  {
    path: '/profile',
    name: 'my-profile',
    components: {
      default: () => import(/* webpackChunkName: "my-profile" */ '../views/MyProfile.vue'),
    },
    meta: {
      title: 'app.page_my_profile',
      requiresAuth: true,
    },
  },

  // Dashboard
  {
    path: '/added-properties',
    name: 'my-adverts',
    components: {
      default: () => import(/* webpackChunkName: "my-properties" */ '../views/MyAdverts.vue'),
    },
    meta: {
      title: 'app.page_my_adverts',
      requiresAuth: true,
    },
  },
  {
    path: '/added-properties/property/:uuid?',
    name: 'my-adverts-edit',
    components: {
      default: () =>
        import(/* webpackChunkName: "properties-editor" */ '../views/AdvertEditor.vue'),
    },
    meta: {
      title: 'app.page_my_adverts_edit',
      requiresAuth: true, // partially true - have a built in login module
    },
  },

  {
    path: '/favorites',
    name: 'my-favorites',
    components: {
      default: () => import(/* webpackChunkName: "my-favorites" */ '../views/MyFavorites.vue'),
    },
    meta: {
      title: 'app.page_my_favorites',
      requiresAuth: true,
    },
  },

  {
    path: '/find-by-preferences',
    name: 'my-preferences',
    components: {
      default: () => import(/* webpackChunkName: "my-references" */ '../views/MyPreferences.vue'),
    },
    meta: {
      title: 'app.page_my_preferences',
      requiresAuth: true,
    },
  },
  {
    path: '/preferences/property/:uuid?',
    name: 'my-preferences-edit',
    components: {
      default: () =>
        import(/* webpackChunkName: "reference-editor" */ '../views/PreferenceEditor.vue'),
    },
    meta: {
      title: 'app.page_my_preferences_edit',
      requiresAuth: false, // partially true - have a built in login module
    },
  },

  {
    path: '/alerts',
    name: 'subscriptions',
    components: {
      default: () =>
        import(/* webpackChunkName: "my-subscriptions" */ '../views/MySubscriptions.vue'),
    },
    meta: {
      title: 'app.page_my_subscriptions',
      requiresAuth: true,
    },
  },

  {
    path: '/notifications',
    name: 'notifications',
    components: {
      default: () => import(/* webpackChunkName: "my-messages" */ '../views/MyNotifications.vue'),
    },
    meta: {
      title: 'app.page_my_notifications',
      requiresAuth: true,
    },
  },
  {
    path: '/for-tenants',
    name: 'renting',
    components: {
      default: () => import(/* webpackChunkName: "my-messages" */ '../views/Renting.vue'),
    },
    meta: {
      title: 'Renting',
      requiresAuth: false,
    },
  },
  {
    path: '/for-landlords',
    name: 'renting-out',
    components: {
      default: () => import(/* webpackChunkName: "my-messages" */ '../views/RentingOut.vue'),
    },
    meta: {
      title: 'Renting Out',
      requiresAuth: false,
    },
  },
];

export default routes;
